export default __webpack_public_path__ + "static/media/customer-ic-star-empty.7ad90b5a.svg";